module.exports = __webpack_public_path__ + "media/Loops 90 Perc.98a4a56d.wav";